import React, { ReactNode } from 'react';
import styled from 'styled-components';

import Footer from '#/components/layout/footer/Footer';
import Header from '#/components/layout/header/Header';
import BannerNotice from '#/components/layout/notice/BannerNoticeWrap';
import NotificationNoticeWrap from '#/components/layout/notice/NotificationNoticeWrap';
import { scrollbarStyle } from '#/styleShared';

const WrapperDesktop = styled.div`
  height: 100vh;
  background: var(--mainDark);
  display: grid;
  grid-template-rows: min-content var(--header-height) max-content 1fr max-content;
  grid-template-areas:
    'notification-notice'
    'header'
    'banner-notice'
    'exchange-body'
    'footer';
`;

const Body = styled.div<{ $isScrollable: boolean }>`
  grid-area: exchange-body;
  position: relative;
  width: 100%;
  max-width: 100vw;
  ${({ $isScrollable }) =>
    $isScrollable
      ? `
        scrollbar-gutter: stable;
        overflow-y: auto;
        overflow-y: overlay;
        ${scrollbarStyle}
        `
      : 'overflow: hidden;'}
`;

type Props = {
  isScrollable: boolean;
  children: ReactNode;
};

function MainLayoutDesktop({ children, isScrollable }: Props) {
  return (
    <WrapperDesktop className="isDesktopStyle">
      <NotificationNoticeWrap />
      <Header />
      <BannerNotice />
      <Body $isScrollable={isScrollable}>
        {children}
        {/* Error overlay - may be usefull for maintenance mode */}
        {/* <div style={{ padding: 50, textAlign: 'center' }}>
          <h1>We cannot reach {KATANA_PERPS} server...</h1>
          <span style={{ color: 'silver' }}>
            {KATANA_PERPS} should be back soon, please wait for automatic reconnect..{' '}
            <br />
          </span>
          // multiple Brs no longer reliable
          <br />
          <br />
          <br />
          <SpinningRoundedBorder />
          <br />
          <div style={{ paddingTop: 50 }}>
            <SimpleRoundedButton>Check connection</SimpleRoundedButton>
          </div>
           <br />
          <Button inline>Try manual reconnect</Button>
          </div>*/}
      </Body>
      <Footer />
    </WrapperDesktop>
  );
}

export default MainLayoutDesktop;
